import { create } from 'zustand';

const useCampaignStore = create((set) => {
    return {
        campaigns: [],
        setCampaigns: (campaigns) => {
            set({ campaigns });
        },
        addCampaign: (campaign) => {
            set((state) => ({ campaigns: [...state.campaigns, campaign] }));
        },
        clearCampaigns: () => {
            set({ campaigns: [] });
        },
    };
});

export default useCampaignStore;